<template>
    <td-dialog :title="title" :before-close="protExdialogClose" :visible.sync="dialogExportVisible" width="400px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="fromExportProtcol" class="demo-form-inline">
            <el-form-item :label="$t('common.PROTCOL_GROUP_NAME')" :label-width="formLabelWidth" prop="groupCaption">
                <td-select v-model="fromExportProtcol.groupCaption" keys="ctlGroupId" text="ctlGroupName" :options="groupCaptionList" :clearable="false"></td-select>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="exportLoading" @click="btnDownLoad">{{ $t('common.DOWNLOAD') }}</td-button>
            <td-button @click="protExdialogClose">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import Api from '../assets/api.js';
import FileDownload from 'js-file-download';
export default {
    props: ['title', 'dialogExportVisible'],
    created() {},
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.initSelect();
    },
    // 定义变量
    data() {
        return {
            fromExportProtcol: { groupCaption: '' },
            formLabelWidth: '30%',
            exportLoading: false,
            groupCaptionList: []
        };
    },
    // 定义并实现方法体
    methods: {
        initSelect() {
            let all = {
                ctlGroupId: -1,
                ctlGroupName: '全部'
            };
            Api.getProtGroupList('{}', response => {
                this.$log.error('alarm/getProtGroupList', response);
                response.data.content.unshift(all);
                this.groupCaptionList = response.data.content;
            });
            this.fromExportProtcol.groupCaption = -1;
        },
        // 关闭窗口之前需要调用的方法
        btnDownLoad() {
            let protGroupId = '';
            if (this.fromExportProtcol.groupCaption !== -1) {
                protGroupId = this.fromExportProtcol.groupCaption;
            }
            let param = {
                ctlGroupId: protGroupId
            };
            this.exportLoading = true;
            Api.compressFile(param, response => {
                this.exportLoading = false;
                this.$log.error('devCtlProt/getProtGroupList', response);
                if (response === null || response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$log.error('devCtlProt/getProtGroupList', response);
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    return;
                }
                if (response.data.statusCode !== this.$t('common.REQUEST_SUCCESS') || response.data.content === null) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('devCtlProt/getProtGroupList', response.data.statusMessage);
                    return;
                }
                let path = response.data.content.filePath;
                if (path === null || path === '') {
                    this.$message.error(this.$t('message.DOWNLOAD_PATH_IS_EMPTY'));
                    return;
                }
                let Base64 = require('js-base64').Base64;
                let param1 = {
                    path: Base64.encode(path)
                };
                let fileName = response.data.content.fileName;
                let responseType = 'arraybuffer';
                Api.exportFile(param1, responseType, response => {
                    if (response === null) {
                        this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                        return;
                    }
                    if (response.status === this.$common.login.RESPONSE_STATUS && response.data) {
                        this.$log.info('/devCtlProt/exportFile', response);
                        FileDownload(response.data, fileName);
                        this.$message({ showClose: true, message: this.$t('message.DOWNLOAD_SUCCESS'), type: 'success' });
                    } else {
                        this.$message({ showClose: true, message: this.$t('message.DOWNLOAD_FAIL'), type: 'error' });
                        this.$log.error('/devCtlProt/exportFile', response);
                    }
                });
            });
        },
        // 关闭窗口之前需要调用的方法
        protExdialogClose() {
            this.$emit('protExdialogClose');
            this.$emit('submit');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
